<div class="entity-container gap-1 {{styleClass}} w-100"
     [ngClass]="{'click-blocked': clickBlocked}"
     (click)="onClick()">
  @if (entityNameHtml) {
    <div class="entity-name text-truncate"
         [ngbTooltip]="entityName"
         overflowTooltip
         [overflowThreshold]="1"
         [innerHTML]="entityNameHtml"
         placement="bottom auto"
         tooltipClass="tooltip-max-230 simple-tooltip"></div>
  } @else if (entityName) {
    <div class="entity-name text-truncate"
         [ngbTooltip]="entityName"
         overflowTooltip
         [overflowThreshold]="1"
         [openDelay]="500"
         placement="bottom auto"
         tooltipClass="tooltip-max-230 simple-tooltip">
      {{ entityName }}</div>
  }

  @if (!clickBlocked) {
    <i class="ph-fill ph-magnifying-glass"></i>
  }
</div>
